const showInteraction = require('../interactions/show');
const forms = require('../components/forms');
const getAnalyticsEventBus = require('../common/getAnalyticsEventBus');

const analyticsEventBus = getAnalyticsEventBus();

const errorElementSelector = '.checkout-error';

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
function clearPreviousErrors(parentSelector) {
  forms.clearFormErrors($(parentSelector));
  $('.error-message').hide();
}

/**
 * Fills and shows the checkout error
 * @param {string} message - Error message to show in Checkout
 */
function addCheckoutError(message) {
  const errorElement = document.querySelector(errorElementSelector);
  errorElement.textContent = message || errorElement.dataset.technicalError;
  showInteraction.show(errorElement);

  const checkoutStageConstants = require('./stage/constants');
  const checkoutStageManager = require('./stage/manager');
  const currentStage = checkoutStageManager.methods.getStage();
  let formName;
  if (
    currentStage === checkoutStageConstants.PAYMENT_DETAILS ||
    currentStage === checkoutStageConstants.SECOND_PAYMENT_DETAILS
  ) {
    const $fieldControl = $(errorElement);
    const getFormName = $fieldControl.siblings('div').find('form').get(1);
    formName = getFormName?.name;
  } else if (currentStage === checkoutStageConstants.PLACE_ORDER) {
    formName = 'purchase-error';
  }

  analyticsEventBus.publish(analyticsEventBus.EVENTS.formErrorShown, {
    errorMessage: message,
    formName,
    pageType: gaInfo.pageType,
  });

  const { checkStageAndScroll } = require('./checkoutCommon').methods;
  checkStageAndScroll();
}

/**
 * Remove checkout error messages
 */
function removeCheckoutError() {
  const errorElement = document.querySelector(errorElementSelector);
  errorElement.textContent = '';
  showInteraction.hide(errorElement);

  const { checkStageAndScroll } = require('./checkoutCommon').methods;
  checkStageAndScroll();
}

module.exports = {
  clearPreviousErrors,
  addCheckoutError,
  removeCheckoutError,
};
